import { render, staticRenderFns } from "./ViewBlacklistEntryModal.vue?vue&type=template&id=108c245a&"
import script from "./ViewBlacklistEntryModal.vue?vue&type=script&lang=js&"
export * from "./ViewBlacklistEntryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports